import { PANCHANG_EVENT_TYPES } from '../config/panchangConfig';

const MONTH_LABEL_FORMATTER = new Intl.DateTimeFormat('en-IN', {
  month: 'long',
  year: 'numeric'
});

const DAY_LABEL_FORMATTER = new Intl.DateTimeFormat('en-IN', {
  weekday: 'short',
  day: '2-digit',
  month: 'short'
});

const curatedFestivalByMonth = {
  2: [{ day: 14, title: 'Holi', type: PANCHANG_EVENT_TYPES.FESTIVAL, note: 'Community puja and festive observances' }],
  7: [{ day: 16, title: 'Janmashtami', type: PANCHANG_EVENT_TYPES.FESTIVAL, note: 'Krishna bhakti and midnight puja' }],
  9: [{ day: 3, title: 'Sharadiya Navratri Begins', type: PANCHANG_EVENT_TYPES.FESTIVAL, note: 'Auspicious for Devi upasana' }],
  10: [{ day: 8, title: 'Diwali Week', type: PANCHANG_EVENT_TYPES.FESTIVAL, note: 'Lakshmi puja planning period' }]
};

const createDate = (year, monthIndex, day) => {
  return new Date(year, monthIndex, Math.max(1, day), 8, 0, 0);
};

const toIsoDate = (date) => {
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const getBasePattern = (year, monthIndex) => {
  return [
    {
      day: 4,
      type: PANCHANG_EVENT_TYPES.AUSPICIOUS,
      title: 'Vinayaka Chaturthi (Monthly)',
      note: 'Favorable for starting spiritual commitments'
    },
    {
      day: 11,
      type: PANCHANG_EVENT_TYPES.EKADASHI,
      title: 'Ekadashi',
      note: 'Ideal for upvas and Vishnu puja'
    },
    {
      day: 15,
      type: PANCHANG_EVENT_TYPES.PURNIMA,
      title: 'Purnima',
      note: 'Good day for Satyanarayan katha and daan'
    },
    {
      day: 26,
      type: PANCHANG_EVENT_TYPES.EKADASHI,
      title: 'Ekadashi',
      note: 'Second Ekadashi observance in this month'
    },
    {
      day: 29,
      type: PANCHANG_EVENT_TYPES.AMAVASYA,
      title: 'Amavasya',
      note: 'Suitable for pitru prayers and deep daan'
    }
  ].map((entry, index) => {
    const date = createDate(year, monthIndex, entry.day);
    return {
      id: `base-${monthIndex}-${index}`,
      date: toIsoDate(date),
      dayLabel: DAY_LABEL_FORMATTER.format(date),
      title: entry.title,
      type: entry.type,
      note: entry.note
    };
  });
};

const getFestivalPattern = (year, monthIndex) => {
  const festivalEntries = curatedFestivalByMonth[monthIndex] || [];
  return festivalEntries.map((entry, index) => {
    const date = createDate(year, monthIndex, entry.day);
    return {
      id: `festival-${monthIndex}-${index}`,
      date: toIsoDate(date),
      dayLabel: DAY_LABEL_FORMATTER.format(date),
      title: entry.title,
      type: entry.type,
      note: entry.note
    };
  });
};

export const getPanchangMonthOptions = (startDate = new Date(), span = 4) => {
  const options = [];
  const startYear = startDate.getFullYear();
  const startMonth = startDate.getMonth();

  for (let offset = 0; offset < span; offset += 1) {
    const date = new Date(startYear, startMonth + offset, 1);
    const year = date.getFullYear();
    const monthIndex = date.getMonth();
    options.push({
      key: `${year}-${String(monthIndex + 1).padStart(2, '0')}`,
      year,
      monthIndex,
      label: MONTH_LABEL_FORMATTER.format(date)
    });
  }

  return options;
};

export const getMonthlyPanchangHighlights = ({ year, monthIndex, city }) => {
  const monthDate = new Date(year, monthIndex, 1);
  const monthLabel = MONTH_LABEL_FORMATTER.format(monthDate);
  const entries = [...getBasePattern(year, monthIndex), ...getFestivalPattern(year, monthIndex)]
    .sort((a, b) => String(a.date).localeCompare(String(b.date)));

  const todayIso = toIsoDate(new Date());
  const todaysEntry = entries.find((entry) => entry.date === todayIso) || entries[0] || null;

  return {
    monthKey: `${year}-${String(monthIndex + 1).padStart(2, '0')}`,
    monthLabel,
    city: city || 'Location not selected',
    today: todaysEntry,
    entries
  };
};
